import { IBasicCommandResponse } from "./ah.mb.client-notifications";
import { FetchWrapper } from "../infrastructure/fetch-wrapper";
 
// Account services

    export class AccountServices {

	// Private declarations

    private rootMvcUrl = ""; 

    private rootApiUrl = "/api/1.0/accounts";

        // Get user list button
		deleteUser =  (username: string): Promise<IBasicCommandResponse> => {

            var deleteUserUrl = this.rootApiUrl + "/" + username + "/delete";

		    var payload = { username: username };

            return FetchWrapper.sendCommandAndHandle(deleteUserUrl,
                {
                     method: "POST", body:JSON.stringify(payload)
                });
		}
	}






// WEBPACK FOOTER //
// ./ClientApp/scripts/ah.modelbuilder.account-services.ts